import _ from "lodash";
import jsonPath from "jsonpath";
import { orderBy } from "natural-orderby";

import book from "content/book.json";
import AppState from "app/state/AppState";
import { onPatch } from "mobx-state-tree";

const { metadata, ...Book } = book;
let pages = _.keys(Book);

const bodyBounds = {
  first: _.findIndex(pages, (entry) => entry.includes("chapter")),
  last: _.findLastIndex(pages, (entry) => entry.includes("chapter")),
};

/* 
//DEBUG:
console.log("bodyBounds First " + bodyBounds.first);
console.log("bodyBounds Last " + bodyBounds.last); */

let frontMatter = pages.slice(0, bodyBounds.first);
//get sections
let section = orderBy(pages.filter((entry) => entry.includes("section")));
let body = orderBy(pages.filter((entry) => entry.includes("chapter")));


/* console.log(
  "body keys before insert = " +
    Object.keys(body) +
    "value: " +
    Object.values(body)
);  */

 
/* console.log("section" + section);
console.log(section[0]);
console.log(section[1]);
console.log(section[2]);
  */

/************* UPDATE CHAPTER SECTION KEY HERE TO  *************************/
/*
INSERT section II, and Section III
NOTE: UPDATE key index to ensure navigation fwd/bwd works
*/
body.splice(5, 0, section[1]); //section II
body.splice(10, 0, section[2]); //section III

/* console.log(" ******************* after splice  ********* ");
Object.keys(body).forEach((prop) => console.log(prop));
Object.values(body).forEach((prop) => console.log(prop));
console.log(" ******************* END after splice  ********* ");
 */
let backMatter = pages.slice(bodyBounds.last + 1);
pages = [...frontMatter, ...body, ...backMatter];

//DEBUG
/* console.log("PAGES LENGTH " + pages.length);
console.log(" ******************* pages after splice  ********* ");
for (var i = 0; i < pages.length; i++) {
  console.log("pages: [" + i + "]" + pages[i]);
} */

/* Object.keys(pages).forEach((prop) => console.log(prop));
Object.values(pages).forEach((prop) => console.log(prop)); */

/* console.log(Object.keys(pages));
console.log(Object.values(pages));
console.log(Object.entries(pages));
 */
const Contents = {};

Contents.source = undefined;

Contents.get = (path) => {
  const book = Contents.source || Book;
  return _.get(book, jsonPath.stringify(path).replace(/^[$.]+/i, ""));
};

Contents.extract = (path, prop) => {
  const book = Contents.source || Book;
  path = _.dropRight(path);
  return _.get(book, `${jsonPath.stringify(path).slice(1)}.${prop}`);
};

const selectedIndex = () => _.indexOf(pages, AppState.selectedSection[1]);

Contents.hasNextSection = () =>
  selectedIndex(AppState.selectedSection) < pages.length - 1;

Contents.hasPreviousSection = () => 0 < selectedIndex(AppState.selectedSection);

Contents.nextSection = () => {
  if (Contents.hasNextSection()) {
    let path = pages[selectedIndex() + 1];
    //12 MAR OEF TOC/SECTION path = path.includes("chapter") ? [path, 0] : [path];
    if (path.includes("chapter")) {
      //DEBUG: console.log("IN IF NEXT SECTION ");
      path = [path, 0];
    } else if (path.includes("section")) {
      //DEBUG:  console.log("IN ELSE IF NEXT SECTION ");
      path = [path, 0];
    } else {
      //DEBUG:  console.log("IN ELSE NEXT");
      path = [path];
    }
    //DEBUG:  console.log("PATH " + path);
    AppState.changeSectionItem(["$", ...path]);
  }
};

Contents.previousSection = () => {
  if (Contents.hasPreviousSection()) {
    let path = pages[selectedIndex() - 1];
    //path = path.includes("chapter") ? [path, 0] : [path];
    //12 MAR 21 OEF TOC/Section change
    if (path.includes("chapter")) {
      path = [path, 0];
    } else if (path.includes("section")) {
      path = [path, 0];
    } else {
      path = [path];
    }
    AppState.changeSectionItem(["$", ...path]);
  }
};

export default Contents;



// WEBPACK FOOTER //
// ./src/app/api/contents.js